export { NoMoreRoomsAvailable } from './NoMoreRoomsAvailable';
